import {
  connect,
} from 'react-redux';
import {
  withTranslation,
} from 'react-i18next';

import {
  actions as authActions,
} from '../../../../redux/modules/auth';

import SessionSectionView from './SessionSectionView';

// Types
import type {
  $State,
} from '../../../../redux';
import type {
  $DispatchProps,
  $OwnProps,
  $StateProps,
} from './SessionSectionView';

const mapStateToProps = ({
  auth,
  main,
}: $State): $StateProps => ({
  auth,
  main,
});

const mapDispatchToProps = (dispatchAction): $DispatchProps => ({
  unauthenticate: () => dispatchAction(
    authActions.unauthenticate(),
  ),
});

const ConnectedComponent = connect<
$StateProps,
$DispatchProps,
$OwnProps,
$State
>(
  mapStateToProps,
  mapDispatchToProps,
)(SessionSectionView);

const TranslatedComponent = withTranslation()(ConnectedComponent);

const Component = TranslatedComponent;

export default Component;
